import { Component, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Card Registration Form';
    
  constructor(public loaderService:LoaderService, private cdRef:ChangeDetectorRef){}
  
  ngAfterViewChecked()
  {
    this.cdRef.detectChanges();
  }
}
